 <template>
  <div class="animated fadeIn">    
      <div class="row">
        <div class="col-sm-12">
          <div v-if="errorMessage.message != ''" class="alert alert-success alert-dismissible">
            <a class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong>Success!</strong>{{errorMessage.message}}
          </div>
        </div>
      </div>
      <b-card no-body>
        <div slot="header" class="title_head">
          Search Customer List
        </div> 
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-row>
              <b-col sm="2">
                <b-form-group >
                  <label for="name">Customer Name : </label>
                   <input type="text" class="form-control" v-model="search.custname" id="custname" name="custname" autocomplete="off" placeholder="Enter Customer Name">
                </b-form-group>
              </b-col>



              <b-col sm="2">
                <b-form-group >
                  <label for="name">Contact No :</label>
                   <input type="text" class="form-control" v-model="search.contact" id="custmob" name="custmob" autocomplete="off" placeholder="Enter Contact No.">
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group >
                  <label for="name">Company Type :</label>
                  <model-list-select :list="srch_cmptyp" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="id" option-text="desc" v-model="search.cmptyp" placeholder="Company Type"></model-list-select>
                </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group >
                  <label for="name">Email :</label>
                   <input type="text" class="form-control" v-model="search.email" id="custemail" name="custemail" autocomplete="off" placeholder="Enter Your Email Address">
                </b-form-group>
              </b-col>




              <b-col sm="2">
                <b-form-group >
                  <label for="name"></label>
                  <button v-if="cust_view === true" type="button" @click.prevent="getCustomer()" class="btn btn-pill btn-primary serach_bttn" style="margin-top: 24px; margin-left: 16%"><i class="fa fa-search"></i>&nbsp;Search</button>
                </b-form-group>
              </b-col>
            </b-row>          
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body>
        <div slot="header" class="title_head">
          <div class="row">
            <div class="col-sm-10">
                Customer List<span>&nbsp;&nbsp;
                <button v-if="cust_rights === true" type="button" class="btn btn-sm btn-primary label_bttn" variant="secondary" @click.prevent="addcustomer()">Add Customer</button></span>
            </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
            <div class="col-sm-1">
                <button 
                  type="button" 
                  class="btn btn-sm btn-primary label_bttn" 
                  v-if="cust_view === true"
                  @click.prevent="exportData()">
                  Export Data
                </button>
            </div>
          </div>

            
        </div>
        
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <vue-good-table 
            :columns="columns"
            :rows="rows"
            mode="remote"
            ref="my-table"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :pagination-options="{enabled: true, perPage: 5,}"
            styleClass="vgt-table striped bordered table-sm condensed">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <i class="fa fa-eye" @click.prevent="viewcustomer(props.row)"></i>
                 
                  <i v-if="cust_rights === true" class="fa fa-edit" @click.prevent="editcustomer(props.row)"></i>
                  <i v-if="cust_rights === true" class="fa fa-trash" @click.prevent="deletecustomer(props.row)"></i> 
                </span>
                 <span v-if="props.column.field == 'cards'">
                    <button class="btn btn-sm btn-primary label_bttn"  @click.prevent="viewcards(props.row)">View Cards</button>
                 </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
              <div slot="emptystate" style="text-align:center;" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
              </div>
            </vue-good-table>

            <b-modal title="View Customer" no-close-on-esc no-close-on-backdrop hide-footer size="lg" v-model="largeModal1" @ok="largeModal1 = false">
              <div class="row">
                <div class="col-md-6">
                  <p><h6>Customer Name:</h6>{{display.name}}</p>
                  <p><h6>Company Type:</h6>{{display.cmptyp}}</p>
                </div>
                <div class="col-md-6">
                  <p><h6>Company email:</h6>{{display.email}}</p>
                  <p><h6>Address:</h6>{{display.add1}}</p>
                </div>
              </div>
            </b-modal>

            <b-modal :title="tit" no-close-on-esc no-close-on-backdrop hide-footer size="lg" class="modal-info" v-model="largeModal" @ok="largeModal = false" style="width: 140%; margin: auto;">
            
            <div class="row">
              <div class="col-md-12">
                <h6 class="page_head">Customer Detail</h6>
                <div class="row">
                  <b-col sm="6">
                    <b-form-group >
                      <label for="name"> Customer Name :<span style="color:red"> *</span></label>
                      <b-form-input type="text" id="name" v-model="customer.name" :class="{'is-invalid':hasErrors.custnm}" autocomplete="off" placeholder="Enter Customer Name"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.custnm" ><strong style="color: red;">Enter Valid comapny Name</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group>
                      <label for="name">Company Type :</label>
                      <model-list-select :list="contyp" class="form-control" style=" -webkit-text-fill-color:rgba(12, 11, 11, 0.87) !important; height:20px !important;" option-value="desc" option-text="desc" v-model="suptype" placeholder="Select Company Type"></model-list-select >
                    </b-form-group>
                  </b-col>
                   <b-col sm="6">
                  <b-form-group>
                    <label for="name">Contact No. : <span style="color:red"> *</span></label>
                    <b-form-input type="text" id="phone" v-model="customer.phone" :class="{'is-invalid':hasErrors.custph}" autocomplete="off" placeholder="Enter Your Contact Number"></b-form-input>
                    <small  class="form-text text-muted" v-if="hasErrors.custph" ><strong style="color: red;">Enter Valid Contact Number</strong></small>
                  </b-form-group>
                </b-col>
                   <b-col sm="6">
                  <b-form-group>
                    <label for="name">Email :</label>
                    <b-form-input type="text" id="email" autocomplete="off" v-model="customer.email" :class="{'is-invalid':hasErrors.custeml}" placeholder="Enter Your E-Mail Id" ></b-form-input>
                    <small  class="form-text text-muted" v-if="hasErrors.custeml" ><strong style="color: red;">Enter Valid Eamil  Id</strong></small>
                  </b-form-group>
                </b-col>
                </div>
                 
                <b-row>
                  <b-col sm="5">
                    <b-form-group>
                      <label for="name">Address Line 1:</label>
                      <b-form-input type="text" id="add1" v-model="customer.add" :class="{'is-invalid':hasErrors.custad1}" @input="shippingenable()" autocomplete="off" placeholder="Enter Customer Address 1"></b-form-input>
                        <small  class="form-text text-muted" v-if="hasErrors.custad1" ><strong style="color: red;">Enter Valid Address 1</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <b-form-group>
                      <label for="name">Address Line 2(optional):</label>
                      <b-form-input type="text" id="add2" v-model="customer.add2" :class="{'is-invalid':hasErrors.custad2}" autocomplete="off" placeholder="Enter  Address Line 2"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.custad2" ><strong style="color: red;">Enter Valid Address 2 </strong></small>
                    </b-form-group>
                  </b-col> 
                  <b-col sm="2">
                    <b-form-group>
                      <label for="name">Pincode :</label>
                      
                      <b-form-input type="text" id="pin" v-model="customer.pin" :class="{'is-invalid':hasErrors.custpin}" autocomplete="off" placeholder="Pincode"></b-form-input>
                   <small  class="form-text text-muted" v-if="hasErrors.custpin" ><strong style="color: red;">Enter Valid Pincode </strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                  
                <b-row> 
                  <b-col sm="4">
                    <b-form-group >
                      <label for="name">Country :</label>
                      <model-list-select :list="conopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="country_name" option-text="country_name" v-model="con" placeholder="Select Country" @input="state1"></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">State :</label>
                      <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="state" placeholder="Select State" @input="city1"></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">City :</label>
                      <model-list-select :list="cityopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="city" placeholder="Select city"></model-list-select>
                    </b-form-group>
                  </b-col> 
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group >
                      <label for="name"> Date of Birth :</label>
                      <date-picker v-model="birth_dt" input-name="date" format="YYYY-MM-DD" editable lang="en" style="width: 0px; min-width: 205px;"></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Anniversary Date :</label>
                      <date-picker v-model="anniversary_dt" input-name="date" format="YYYY-MM-DD" editable lang="en" style="width: 0px; min-width: 205px;"></date-picker>
                    </b-form-group>
                  </b-col>
                  </b-row>

          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">Corporate Identity Number:</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="cin" v-model="customer.cin" onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company Identity Number" aria-label="Enter Corporate Identity Number" aria-describedby="btnGroupAddon" autocomplete="off" :class="{'is-invalid':hasErrors.custcin}">
                    </div>
                    <small class="form-text text-muted" v-if="hasErrors.custcin" ><strong style="color: red;">Enter Valid CIN </strong></small>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">CIN Certificate : </label>
                    <input :class="{'is-invalid':hasErrors.image1}" type="file" name="image1" id="image1" accept="image/*" autocomplete="off" class="form-control">
                    <small class="form-text text-muted" v-if="hasErrors.image1"><strong style="color: red;">{{errorMessage.image1}}</strong></small>
                    <p v-if="ed.image1!=''">View Uploaded File : <a :href="ed.image1_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">GST/VAT Number :</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="cust_gst" v-model="customer.gst" onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company GST/VAT Number" aria-label="Input group example"  autocomplete="off" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.custgst}">
                    </div>
                    <small class="form-text text-muted" v-if="hasErrors.custgst"><strong style="color: red;">Enter Valid GST </strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">GST Certificate:</label>
                    <input :class="{'is-invalid':hasErrors.image2}" type="file" name="image2" id="image2" accept="image/*" autocomplete="off" class="form-control">
                    <small class="form-text text-muted" v-if="hasErrors.image2"><strong style="color: red;">{{errorMessage.image2}}</strong></small>
                    <p v-if="ed.image2!=''">View Uploaded File : <a :href="ed.image2_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>
               
               <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">PAN Number:</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="cust_pan" v-model="customer.pan" onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company PAN Number" aria-label="Input group example" autocomplete="off" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.custpan}">
                    </div>
                    <small class="form-text text-muted" v-if="hasErrors.custpan"><strong style="color: red;">Enter Valid PAN </strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">PAN Certificate:</label>
                    <input :class="{'is-invalid':hasErrors.image3}" type="file" name="image3" id="image3" accept="image/*" autocomplete="off" class="form-control">
                    <small class="form-text text-muted" v-if="hasErrors.image3"><strong style="color: red;">{{errorMessage.image3}}</strong></small>
                    <p v-if="ed.image3!=''">View Uploaded File : <a :href="ed.image3_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">TAN Number :</label>
                    <div class="input-group">
                      <input type="text" class="form-control" id="tan" v-model="customer.tan" onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company Tan Number" aria-label="Input group example" autocomplete="off" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.custtan}">
                    </div>
                    <small class="form-text text-muted" v-if="hasErrors.custtan"><strong style="color: red;">Enter Valid TAN </strong></small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="name">TAN Certificate:</label>
                    <input :class="{'is-invalid':hasErrors.image4}" type="file" name="image4" id="image4" autocomplete="off" accept="image/*" class="form-control">
                    <small class="form-text text-muted" v-if="hasErrors.image4"><strong style="color: red;">{{errorMessage.image4}}</strong></small>
                    <p v-if="ed.image4!=''">View Uploaded File : <a :href="ed.image4_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>

            </div>
            
            <div class="col-md-4">
              <div class="row">
              
             
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="name">Company Logo :</label>
                    <input :class="{'is-invalid':hasErrors.image5}" type="file" name="image5" id="image5" autocomplete="off" accept="image/*" class="form-control">
                    <small class="form-text text-muted" v-if="hasErrors.image5"><strong style="color: red;">{{errorMessage.image5}}</strong></small>
                    <p v-if="ed.image5!=''">View Uploaded File : <a :href="ed.image5_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-12">
          <h6 class="page_head">Contact Person Detail</h6>
               
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <label for="name">Contact Person Name :</label>
                <b-form-input type="text" id="contact" v-model="customer.contact" :class="{'is-invalid':hasErrors.custcont}" autocomplete="off" placeholder="Enter Contact Person Name"></b-form-input>
                <small  class="form-text text-muted" v-if="hasErrors.custcont" ><strong style="color: red;">Enter Valid  Name</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name">Contact Number :</label>
                <b-form-input type="text" id="contactno" v-model="customer.contactno" :class="{'is-invalid':hasErrors.custcontno}" autocomplete="off" placeholder=" Enter Contact Contact Number"></b-form-input>
                <small  class="form-text text-muted" v-if="hasErrors.custcontno" ><strong style="color: red;">Enter Valid Contact Number</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label for="name">Contact Email :</label>
                <b-form-input type="text" id="contactemail" v-model="customer.contactemail" autocomplete="off" :class="{'is-invalid':hasErrors.custconteml}" placeholder="Enter Contact Person E-mail Id"></b-form-input>
                <small class="form-text text-muted" v-if="hasErrors.custconteml" ><strong style="color: red;">Enter Valid Eamil Id </strong></small>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="name">Customer Company Profile :</label>
                 <small class="form-text text-muted" v-if="hasErrors.supplierprf" ><strong style="color: red;">Profile cannot be greater than 255 Character</strong></small>
               <vue-editor  v-model="customer.profile" :editorToolbar="customToolbar"></vue-editor>
              </b-form-group>
            </b-col>
          </b-row>

          
          <h6 class="page_head">Bank Details</h6>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Bank Name :</label>
                  <input type="text" class="form-control" id="bankname" v-model="customer.bankname" autocomplete="off" :class="{'is-invalid':hasErrors.bankname}" placeholder="Enter your Bank Name">
                  <small class="form-text text-muted" v-if="hasErrors.bankname" ><strong style="color: red;">Enter Valid Bank Name</strong></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Account Number :</label>
                  <input type="text" class="form-control" id="banknumber" name="banknumber" autocomplete="off" v-model="customer.banknumber" :class="{'is-invalid':hasErrors.banknumber}" placeholder="Enter your Bank Account Number">
                  <small class="form-text text-muted" v-if="hasErrors.banknumber"><strong style="color: red;">Enter Valid Bank Account Number</strong></small>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Account Holder Name :</label>
                  <input type="text" class="form-control" id="bankholder" name="bankholder" v-model="customer.bankholder" autocomplete="off" :class="{'is-invalid':hasErrors.bankholder}" placeholder="Enter Account Holder Name">
                  <small class="form-text text-muted" v-if="hasErrors.bankholder"><strong style="color: red;">Enter Valid Account Holder Name</strong></small>
                </div>
              </div>
            </div>
                
            <div class="row">   
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">IFSC Code :</label>
                  <input type="text" class="form-control" id="bankifsc" name="bankifsc" v-model="customer.bankifsc" autocomplete="off" :class="{'is-invalid':hasErrors.bankifsc}" placeholder="Enter Bank IFSC Code">
                  <small class="form-text text-muted" v-if="hasErrors.bankifsc"><strong style="color: red;">Enter Valid IFSC Code</strong></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Branch :</label>
                  <input type="text" class="form-control" id="bankbranch" name="bankbranch" v-model="customer.bankbranch" autocomplete="off"  :class="{'is-invalid':hasErrors.bankbranch}" placeholder="Enter Branch Name">
                  <small class="form-text text-muted" v-if="hasErrors.bankbranch"><strong style="color: red;">Enter Valid Bank Branch</strong></small>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">MICR Code :</label>
                  <input type="text" class="form-control" id="bankmicr" name="bankmicr" v-model="customer.bankmicr" :class="{'is-invalid':hasErrors.bankmicr}" autocomplete="off" placeholder="Enter MICR code">
                  <small class="form-text text-muted" v-if="hasErrors.bankmicr"><strong style="color: red;">Enter Valid MICR Code</strong></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Swift Code :</label>
                  <input type="text" class="form-control" id="bankswift" name="bankswift" v-model="customer.bankswift" :class="{'is-invalid':hasErrors.bankswift}" autocomplete="off" placeholder="Enter Bank Swift Code">
                  <small class="form-text text-muted" v-if="hasErrors.bankswift"><strong style="color: red;">Enter Valid Swift Code</strong></small>
                </div>
              </div>   
            </div>

          <h6 class="page_head">Shipping Details</h6>
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Name </label>
                  <input type="text" class="form-control" id="sname" v-model="address.sname" placeholder="Enter Name" autocomplete="off"  :class="{'is-invalid':hasErrors1.errsname}" :disabled="shipdisable">
                  <small class="form-text text-muted" v-if="hasErrors1.errsname"><strong style="color: red;">{{hasErrors1.errsname}}</strong></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Address</label>
                  <input type="text" class="form-control" id="saddress" name="saddress" v-model="address.saddress" autocomplete="off"  placeholder="Enter Address" :class="{'is-invalid':hasErrors1.errsaddress}"  :disabled="shipdisable">
                   <small class="form-text text-muted"  v-if="hasErrors1.errsaddress"><strong style="color: red;">{{hasErrors1.errsaddress}}</strong></small>
                </div>
              </div>
               <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Contact Number </label>
                  <input type="text" class="form-control" autocomplete="off"   v-model="address.sphn" placeholder="Enter Phone Number" :class="{'is-invalid':hasErrors1.errsphn}" :disabled="shipdisable">
                  <small class="form-text text-muted" v-if="hasErrors1.errsphn"><strong style="color: red;">{{hasErrors1.errsphn}}</strong></small>
                </div>
              </div>
            </div>

             <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">State </label>
                  <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="shippingstate" placeholder="Select State" @input="shipping_city"></model-list-select>
                  <!-- <input type="text" class="form-control" autocomplete="off"  v-model="address.sstate" placeholder="Enter State" :class="{'is-invalid':hasErrors1.errsstate}"> -->
                  <small class="form-text text-muted" v-if="hasErrors1.errsstate"><strong style="color: red;">{{hasErrors1.errsstate}}</strong></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">City</label>
                  <model-list-select :list="shippingcityopt" class="form-control"
                    style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="shippingcity" placeholder="Select city"></model-list-select>
                  <!-- <input type="text" class="form-control" autocomplete="off"  v-model="address.scity" placeholder="Enter City" :class="{'is-invalid':hasErrors1.errscity}"> -->
                  <small class="form-text text-muted" v-if="hasErrors1.errscity"><strong style="color: red;">{{hasErrors1.errscity}}</strong></small>
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name">Pincode</label>
                  <input type="text" class="form-control" autocomplete="off"   v-model="address.spincode" placeholder="Enter Pincode" :class="{'is-invalid':hasErrors1.errspincode}" :disabled="shipdisable">
                  <small class="form-text text-muted"  v-if="hasErrors1.errspincode"><strong style="color: red;">{{hasErrors1.errspincode}}</strong></small>
                </div>
              </div>
            </div>
            <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="name">GST Number :</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="gst" v-model="address.sgst"
                    onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company GST/VAT Number"
                    aria-label="Input group example" autocomplete="off" aria-describedby="btnGroupAddon"
                    :class="{'is-invalid':hasErrors1.errsgst}" :disabled="shipdisable">
                </div>
                <small class="form-text text-muted" v-if="hasErrors1.errsgst"><strong style="color: red;">Enter Valid GST</strong></small>
              </div>
            </div>
               <div class="col-sm-2">
                <div class="form-group">
                  <label for="name"><br> </label><br>
                  <small><button  class="btn btn-sm btn-primary" name="add" @click="addValues()" :disabled="shipdisable">Add</button></small>
                </div>
              </div>
            </div><br><br>
            <div class="row" v-for="(address1, index) in addr">
                <div class="col-sm-10">
                  <div class="form-group">
                    <b>{{address1.yname}}&nbsp;({{address1.yphn}})</b><br>
                    <span>{{address1.ygst}}</span><br>
                    <span v-if="address1.yaddress!=''">
                     {{address1.yaddress}}<br></span>
                    <span v-if="address1.ystate != '' && address1.ycity != '' && address1.ypincode != ''">
                     {{address1.ystate}} &nbsp; {{address1.ycity}} - {{address1.ypincode}}
                    </span>
                  </div> 
                </div>
                  
                <div class="col-sm-2" style="color:#f86c6b;font-size: 20px; cursor: pointer;">
                  <span v-if="address1.chkship_id!=1">
                  <i class="fa fa-trash"  @click.prevent="deleteadd(index)"></i>
                  </span> 
                </div><hr width="97%">
              
              </div>


          </div>
        </div>
             
        <div class="card-footer modal_footer">
          <b-row>
            <b-col sm="12">
               <button type="save" class="btn btn-sm btn-primary" v-if="saveBtn" @click.prevent="Submit()"><i class="fa fa-dot-circle-o"></i> Save</button>
               <button type="save" class="btn btn-sm btn-warning" v-if="editBtn" @click.prevent="Update()"><i class="fa fa-dot-circle-o"></i> Update</button>
            </b-col>
          </b-row>
        </div>
            </b-modal>
            <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only 
            v-model="plan_modal"
          >
          <b-row>
            <b-col sm="2">
                <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding Customers. Please upgrade your plan to add more Customers.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
          </b-card-body>
        </b-collapse>
      </b-card>

  <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>

  import Spinner from '../../spinner.vue'
  import { VueEditor } from 'vue2-editor'
  import DatePicker from 'vue2-datepicker'
  export default {
    name:'customer',
    components: {
      'date-picker':  DatePicker,
      VueEditor,Spinner
    },
    data () {
      return {
        shipdisable:true,
        birth_dt: '',
        anniversary_dt: '',
        tit:'',
        access_token:null,
        plan_modal:false,
        customToolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }]
        ],
        cfrst_time:false,
        conf_time:false,
        comf_time:false,
        customer_id:'',
        selectcompany: null,
        largeModal1:false,
        largeModal:false,
        saveBtn:false,
        editBtn:true,
        loading:false,
        suptype:null,
        state: null,
        //
        todate: "",
        fromdate: "",
        ///
        city:null,
        shippingstate: null,
        shippingcity: null,
        // sstate: null,
        con:null,
        cityopt:[],
        shippingcityopt:[],
        stateopt:[],
        conopt:[],
        maximumSize: 500000,
        allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        contyp:[],
        srch_cmptyp:[], 
        totalRecords: 0,
        serverParams: {
        columnFilters: {},
        sort: {
          // field: 'purchase_id', 
          // type: 'asc',
        },
        page: 1, 
        perPage: 5
        },
        address:{
          sname:'',
          saddress:'',
          spincode:'',
          sstate:'',
          sstateid:'',
          scity:'',
          scityid:'',
          sphn:'',
          sgst:'',
        },
        addr:[],
        display:{
          name:null,
          cmptyp:null,
          email:null,
          add1:null,
        },
        customer:{
          add:'',
          name:'',
          add2:'',
          pin:'',
          phone:'',
          email:'',
          gst:'',
          pan:'',
          cin:'',
          tan:'',
          contact:'',
          contactno:'',
          contactemail:'',
          profile:'',
          image:'',
          bankname:'',
          banknumber:'',
          bankholder :'',
          bankifsc:'',
          bankbranch:'',
          bankmicr :'',
          bankswift :'',
        },
        search:{
          custname:'',
          cmptyp:null,
          email:'',
          contact:'',

        },
        columns: [
          {
            label: 'Customer Name',
            field: 'cust_cmp_name',
            width: '15% !important'
          },
          // {
          //   label: 'Company Type',
          //   field: 'companytypes.desc',
          //   width: '15% !important'
          // },
          {
            label: 'Contact No.',
            field: 'cust_cmp_phone',
            width: '10% !important'
          },
          {
            label: 'Email',
            field: 'cust_cmp_email',
            width: '15% !important'
          },
          {
            label: 'Wallet Balanace',
            field: 'total_wallet_amount',
            width: '15% !important'
          },
          {
            label: 'Action',
            field: 'action',
            width: '15% !important'
          },
          {
            label: 'Cards',
            field: 'cards',
            width: '15% !important'
          },
      ],

      rows: [],
      // address:[],
      ed:{
        image1:'',
        image2:'',
        image3:'',
        image4:'',
        image5:'',
        image1_href:'',
        image2_href:'',
        image3_href:'',
        image4_href:'',
        image5_href:'',
      },
      hasErrors1:{
        errsname:false,
        errsaddress:false, 
        errsstate:false,
        errscity:false,
        errspincode:false,
        errsphn:false, 
        errsgst:false
      },
      hasErrors:{
        message:false,
        custnm:false,
        custad1:false,
        custad2:false,
        custpin:false,
        custph:false,
        custeml:false,
        custgst:false,
        custpan:false,
        custcin:false,
        custtan:false,
        custcont:false,
        custcontno:false,
        custconteml:false, 
        supplierprf:false,
        image1:false,
        image2:false,
        image3:false,
        image4:false,
        image5:false,
        bankname:false,
        banknumber:false,
        bankholder :false,
        bankifsc:false,
        bankbranch:false,
        bankmicr:false,
        bankswift:false,
      },
      errorMessage:{
        message:'',
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null,
      }
    }
  },
  computed: {
    cust_view: function(){
      if(this.$store.getters.get_cust_view === true){
          this.getCustomer('comp');
          this.contr('comp');
          this.companytype('comp');
          this.contr1ed('101');
          this.state1ed('22');
          this.city1ed('2707');
          return true
      }
      else{
        return false
      }
    },

    cust_rights: function(){
      return this.$store.getters.get_cust_rights
    },
  },

  
  created(){
    if(localStorage.authUser != null){
      this.access_token = '?access_token='+localStorage.authUser
    }

    // var roles = JSON.parse(localStorage.getItem('roles'))
    // if(roles[7].page_name == 8){
    //   this.pg_view = roles[7].view
    //   this.pg_rights = roles[7].rights
    //   if(this.pg_view){
    //     this.getCustomer();
    //     this.contr();
    //     this.companytype();
    //   }
    // }
    
  },
  methods:{
    updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
           this.updateParams({page: params.currentPage});
           this.getCustomer();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.getCustomer();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.getCustomer();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.getCustomer();
    },

    deleteadd(indx)
    {
        this.addr.splice(indx, 1);
    },
    shippingenable(){
      // console.log('shipping enable')
      if(this.customer.add.trim() !== ""){
        this.shipdisable = false
      }
      else{
        this.shipdisable = true
      }
    },
    addValues(){   
      if(this.shippingcity !== null){
        this.address.scity = this.shippingcity.city_name
        this.address.scityid = this.shippingcity.id
        }
        var phnrex=/^[0-9]{10,15}$/
        var pinrex =/^\d{0}$|^\d{6}$/
        var nrex =/^[a-zA-Z\s]{0}$|^[a-zA-Z\s]{2,50}$/ 
        var nmrex = /^[a-zA-Z\s]{2,50}$/
        var regex = /^[a-zA-Z0-9\s]{3,100}$/
        var _this = this
        var nm = this.address.sname
        var adrs = this.address.saddress
        var pncd = this.address.spincode
        var st = this.address.sstate
        var ct = this.address.scity
        var phn = this.address.sphn
        var stid = this.address.sstateid
        var ctid = this.address.scityid
        var gst = this.address.sgst
        var add_true = 1
        _this.hasErrors1.errscity='';
        _this.hasErrors1.errsstate='';
        _this.hasErrors1.errsphn= '';
        _this.hasErrors1.errspincode='';
        _this.hasErrors1.errsaddress='';
        _this.hasErrors1.errsname='';
         _this.hasErrors1.errsgst = '';
        if(nm == undefined)
        {
          nm =''
        }
       
        if(adrs == undefined)
        {
          adrs =''
        }

        if(phn == undefined)
        {
          phn =''
        }

        if(pncd == undefined)
        {
          pncd =''
        }

        if(ct == undefined)
        {
          ct =''
        }

        if(st == undefined)
        {
          st =''
        }
        if(gst === undefined){
          gst = ''
        }
         

        if(nm === '')
        {
          add_true = 0
          this.hasErrors1.errsname ='Required'
        }
        else if((nm.length < 2 || nm.length >50) && nm!='' )
        {
          add_true = 0
          this.hasErrors1.errsname ='Enter maximum 50 and minimum 2 letters'
        }

        if (gst !== "") {
          if (regex.test(gst) === false) {
            add_true = 0
            this.hasErrors1.errsgst = true
          } else if (gst.length > 15) {
            add_true = 0
            this.hasErrors1.errsgst = true;
          }
        }

      if(adrs =='' && nm == '' && phn==''){
          add_true=0
        }
        if(adrs =='' && nm=='' && phn=='' && st=='' && ct=='' && pncd=='')
        {
          add_true=0
        }
        if(adrs =='' )
        { 
          this.hasErrors1.errsaddress='Required';
          add_true = 0
        }
        else if(adrs.length < 2 || adrs.length >200 )
         {
           this.hasErrors1.errsaddress ='Enter maximum 200 and minimum 2 letters'
              add_true = 0
         }
         else{
          
        }
        
          if(phnrex.test(phn)==false)
          {
            if(phn =='')
              { 
                this.hasErrors1.errsphn='Required'; 
              }else if(phn.length < 10 || phn.length >15 )
              {
                this.hasErrors1.errsphn ='Enter maximum 15 and minimum 10 numbers'
              }else
              {
                this.hasErrors1.errsphn ='Enter valid phone number'
              }
         
              add_true = 0
          } 
        
           
         if(pinrex.test(pncd) == false)
           {  
            if(pncd != '')
                { 
                   this.hasErrors1.errspincode ='Enter valid pincode'
                   add_true = 0 
                }
           } 
           
          //  if(nrex.test(ct) == false)
          //  {    
          //      if(ct.length < 2 || ct.length >50 )
          //       {
          //         this.hasErrors1.errscity ='Enter maximum 50 and minimum 2 letters'
          //       }
          //       else
          //       {
          //         this.hasErrors1.errscity ='Enter valid city'
          //       }
          //        add_true = 0
            
          //  } 
           

          // if(nrex.test(st) == false)
          //  {      
          //    if(st.length < 2 || st.length >50 )
          //     {
          //       this.hasErrors1.errsstate ='Enter maximum 50 and minimum 2 letters'
          //     }
          //     else
          //     {
          //       this.hasErrors1.errsstate ='Enter valid state'
          //     }
          //      add_true = 0
             
          //  } 
        if(add_true  == 1){     
            this.addr.push({yname:nm, yaddress:adrs,ypincode:pncd,ystate:st,ycity:ct,yphn:phn,ystateid:stid,ycityid:ctid,ycountry:this.con.id,ygst:gst})
            this.address.sname = ''
            this.address.saddress = ''
            this.address.spincode = ''
            this.address.sstate = ''
            this.address.sstateid = ''
            this.address.scity = ''
            this.address.scityid = ''
            this.address.sphn = ''
            this.address.sgst = ''
            this.shippingstate = null
            this.shippingcity = null
        }
      },
    
    
    addcustomer(){
       var _this = this
        this.loading = true;
        // this.$http.get('/api/customers/chk_plan_count').then(function(response){
        //   console.log(response.data.message)
          _this.loading = false;
          // if('message' in response.data){
          //   if(response.data.message === true){
          //     _this.plan_modal = true
          //   }
          //   else{
              _this.plan_modal = false
              _this.tit = "Add Customer"
              _this.addr=[]
              _this.shipdisable = true
              _this.saveBtn = true
              _this.editBtn = false
              _this.contr1ed('101');
              _this.state1ed('22');
              _this.city1ed('2707');
              _this.largeModal = true
              _this.reset_error()
              _this.reset();
              _this.address.sname=''
              _this.address.saddress=''
              _this.address.spincode=''
              _this.address.sstate=''
              _this.address.sstateid = ''
              _this.address.scity=''
              _this.address.scityid=''
              _this.address.sphn =''
              _this.hasErrors1.errscity='';
              _this.hasErrors1.errsstate='';
              _this.hasErrors1.errsphn= '';
              _this.hasErrors1.errspincode='';
              _this.hasErrors1.errsaddress='';
              _this.hasErrors1.errsname='';
            },
          // }
          // else{
          //   console.log('something went wrong')
          // }
          // }).catch(function(error){
          //   console.log(error)
          // });
    // },
    viewcards(customerid){
      // this.customerid.length = 0;
            var _this = this
            _this.$router.props = [customerid.customer_id];
            localStorage.setItem("customer_id", JSON.stringify(customerid.customer_id));
            _this.$router.push("/custcardlist");
            console.log('His'+customerid.customer_id);
       
    },

    customers(){
       var _this=this
         var filteParam = {};
      //  filteParam.page = this.serverParams2.page;
      // filteParam.perPage = this.serverParams2.perPage;
      // filteParam.sort = this.serverParams2.sort;
         this.customer_id = JSON.parse(localStorage.getItem('customer_id'));
      // this.$http.get('/api/customermonthentries/CustomerCards')
    
       var data = "&filter[where][customer_id]=" + this.customer_id;
      this.$http
        .get(
          "/api/customercards/allCards?params=" +
            JSON.stringify(filteParam) +
            data
        ).then(function (response) {
        _this.rows4 =response.data
      
      });
    },
    viewcustomer(customerid){
      var _this = this
      _this.display.name = null
      _this.display.cmptyp = null
      _this.display.email = null
      _this.display.add1 = null
      this.largeModal1 = true
      _this.display.name = customerid.cust_cmp_name
      // _this.display.cmptyp = customerid.cust_cmp_type
      _this.display.cmptyp = customerid.companytypes.desc
      _this.display.email = customerid.cust_cmp_email
      _this.display.add1 = customerid.address1
    },

    contr1ed(option){
      var _this=this
      this.$http.get('/api/countries/'+option).then(function(response){
        _this.con = response.data
      }).catch(function(error){
        console.log(error)
      })

      this.$http.get('/api/states?&filter[where][country_id]='+option).then(function(response){
        _this.stateopt = response.data;
      }).catch(function(error){
        console.log(error)
      })

    },

    state1ed(conopt){
      var _this=this
      this.$http.get('/api/states/'+conopt).then(function(response){
        _this.state = response.data;
      }).catch(function(error){
        console.log(error)
      })

      this.$http.get('/api/cities?filter[where][state_id]='+conopt).then(function(response){
        _this.cityopt = response.data
      }).catch(function(error){
        console.log(error)
      })
    },

    city1ed(stateopt){
      var _this=this
      this.$http.get('/api/cities/'+stateopt).then(function(response){
        _this.city = response.data
      }).catch(function(error){
        console.log(error)
      })
    },
    suptyp1ed(suptypopt){
      var _this=this
      this.$http.get('/api/companytypes/'+suptypopt).then(function(response){
        _this.suptype = response.data
      }).catch(function(error){
        console.log(error)
      })
    },
    getshippingDetails(customer_id,company_id){ 
      if(this.addr.length > 0){
          for (var i = this.addr.length-1; i >=0;  i--) {
            this.addr.splice(i,1);
          }
        }
        var data=[]
        var _this =this
        this.$http.get('/api/customershippspecs?filter[where][customer_id]='+this.customer_id).then(function(response){
          var addr_data = response.data['ship_dt']
          var state_dt = response.data['state_dt']
          var city_dt = response.data['city_dt']
          for (var i = 0; i < addr_data.length; i++) {
            _this.addr.push({yname:addr_data[i].customer_name, yaddress:addr_data[i].address,ypincode:addr_data[i].pincode,ystate: state_dt[addr_data[i].state_code],ystateid:addr_data[i].state_code,ycity:city_dt[addr_data[i].city],ycityid:addr_data[i].city,yphn:addr_data[i].contact_no,chkship_id:addr_data[i].shipp_id,ygst: addr_data[i].gst_no})
          }
        })
        .catch(function(error){
          console.log(error)
        })
    },
    editcustomer(customerid){
     
      this.reset_error()
      this.reset();
      this.tit = "Edit Customer"
      this.saveBtn = false
      this.editBtn = true
      this.largeModal = true
      this.customer.name = customerid.cust_cmp_name
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
     
      if(customerid.cust_cmp_type!=null){
        this.suptyp1ed(customerid.cust_cmp_type)
      }
      this.customer.add = customerid.address1
      if(this.customer.add.trim() !== ""){
        this.shipdisable = false
      }
      else{
        this.shipdisable = true
      }
      this.customer.add2 = customerid.address2
      if(customerid.country_code!=null){
        this.contr1ed(customerid.country_code)
      }
      if(customerid.state_code!=null){
        this.state1ed(customerid.state_code)
      }
      if(customerid.city!=null){
        this.city1ed(customerid.city)
      }
      this.birth_dt = customerid.birth_date
      this.anniversary_dt = customerid.anniversary_date
      this.customer.pin = customerid.pincode
      this.customer.phone = customerid.cust_cmp_phone
      this.customer.email = customerid.cust_cmp_email
      this.customer.gst = customerid.cust_cmp_gst
      this.customer.pan = customerid.cust_cmp_pan
      this.customer.cin = customerid.cust_cmp_cin
      this.customer.tan = customerid.cust_cmp_tan
      this.customer.contact = customerid.contact_person_name
      this.customer.contactno = customerid.contact_no
      this.customer.contactemail = customerid.contact_email
      this.customer.profile = customerid.customerdetailss.cust_cmp_profile
      this.customer.bankname = customerid.customerbanks.bank_name
      this.customer.banknumber = customerid.customerbanks.acc_number
      this.customer.bankholder = customerid.customerbanks.bank_holder_name
      this.customer.bankifsc = customerid.customerbanks.ifsc_code
      this.customer.bankbranch = customerid.customerbanks.branch
      this.customer.bankmicr = customerid.customerbanks.micr_code
      this.customer.bankswift = customerid.customerbanks.swift_code
      this.ed.image1 = customerid.customerdetailss.cust_cmp_cic_cert
      this.ed.image2 = customerid.customerdetailss.cust_cmp_gst_cert
      this.ed.image3 = customerid.customerdetailss.cust_cmp_pan_cert
      this.ed.image4 = customerid.customerdetailss.cust_cmp_tan_cert
      this.ed.image5 = customerid.customerdetailss.cust_cmp_logo
      this.ed.image1_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+customerid.customerdetailss.cust_cmp_cic_cert+this.access_token
      this.ed.image2_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+customerid.customerdetailss.cust_cmp_gst_cert+this.access_token
      this.ed.image3_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+customerid.customerdetailss.cust_cmp_pan_cert+this.access_token
      this.ed.image4_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+customerid.customerdetailss.cust_cmp_tan_cert+this.access_token
      this.ed.image5_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+customerid.customerdetailss.cust_cmp_logo+this.access_token
      this.customer_id = customerid.customer_id
      this.company_id = customerid.company_id
      this.getshippingDetails(this.customer_id,this.company_id)
    },
    getCustomer(val){
      if(val === 'comp'){
          if(this.cfrst_time === false){
            this.cfrst_time = true
          }
          else{
            return
          }
        }
      var _this=this
      var data = [];
      this.rows = [];
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var custname = this.search.custname
      var email = this.search.email
      var contact = this.search.contact
      custname = custname.split(' ').join('_')
      email = email.split(' ').join('_')
      contact = contact.split(' ').join('_')
      if(this.search.custname!=''){
        data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
      }
      if(this.search.cmptyp!=null){
        if(this.search.cmptyp.id!=undefined){
          var cmptyp = this.search.cmptyp.id
          data= data+"&filter[where][cust_cmp_type]="+cmptyp          
        }
      }
      if(this.search.email!=''){
        data= data+"&filter[where][cust_cmp_email][ilike]=%"+email+"%"
      }
       if(this.search.contact!=''){
        data= data+"&filter[where][cust_cmp_phone][ilike]=%"+contact+"%"
      }
      // this.loading = true
      this.$http.get('/api/customers/customer_search?params='+JSON.stringify(filteParam)+data)
      .then(function(response){
         _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          _this.rows=response.data;
          
          // _this.loading = false
      }).catch(function(error){
        console.log(error)
      })
    },

    deletecustomer(customerid){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
      var _this = this
      var id = customerid.id;
      this.loading=true
      this.$http.delete('/api/customers/'+id).then(function (response){
        
        _this.getCustomer();
        _this.loading=false
      })
      .catch(function (error){
        _this.loading=false
        console.log(error);
      });
      }
    },

    companytype(val){
      if(val === 'comp'){
          if(this.comf_time === false){
            this.comf_time = true
          }
          else{
            return
          }
        }
      var _this=this
      this.$http.get('/api/companytypes').then(function(response){
        _this.contyp = response.data
        _this.srch_cmptyp = response.data
      }).catch(function(error){
        console.log(error)
      })
    },

    contr(val){
      if(val === 'comp'){
          if(this.conf_time === false){
            this.conf_time = true
          }
          else{
            return
          }
        }
      var _this=this
      this.cityopt = []
      this.city=null
      this.stateopt = []
      this.state=null
      this.$http.get('/api/countries').then(function(response){
        _this.conopt=response.data;        
      }).catch(function(error){
        console.log(error)
      })
    },

    state1(conopt){
      this.cityopt = []
      this.city=null
      var _this=this
      this.$http.get('/api/states?filter[where][country_id]='+conopt.id)
      .then(function(response){
        _this.stateopt = response.data;
      }).catch(function(error){
        console.log(error)
      })
    },

    city1(stateopt){
      this.cityopt=[];
      this.city=null
      var _this=this
      this.$http.get('/api/cities?filter[where][state_id]='+stateopt.id)
      .then(function(response){
        _this.cityopt=  response.data;
      }).catch(function(error){
        console.log(error)
      })
    },

    shipping_city(stateopt){
      this.address.sstate = stateopt.state_name
      this.address.sstateid = stateopt.id
      this.shippingcityopt=[];
      this.shippingcity=null
      var _this=this
      this.$http.get('/api/cities?filter[where][state_id]='+stateopt.id)
      .then(function(response){
        _this.shippingcityopt=  response.data;
      }).catch(function(error){
        console.log(error)
      })
    },

    image1(callback){
      var _this = this
      const image1 = document.querySelector('#image1');
      if(this.ed.image1!=='' && this.ed.image1!==null){
        if(image1.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image1)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image1
        }
      }else{
        if(image1.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return '';
        }        
      }
    },

    image2(callback){
      var _this = this
      const image2 = document.querySelector('#image2');
      if(this.ed.image2!=='' && this.ed.image2!==null){
        if(image2.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image2)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image2
        }
      }else{
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';        
        }
      }
    },

    image3(callback){
      var _this = this
      const image3 = document.querySelector('#image3');
      if(this.ed.image3!=='' && this.ed.image3!==null){
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image3)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image3
        }
      }else{
        // const image3 = document.querySelector('#image3');
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
    },

    image4(callback){
      var _this = this
      const image4 = document.querySelector('#image4');
      if(this.ed.image4!=='' && this.ed.image4!==null){
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image4)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image4
        }
      }else{
        if(image4.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
    },


    image5(callback){
      var _this = this
      const image5 = document.querySelector('#image5');
      if(this.ed.image5!=='' && this.ed.image5!==null){
        if(image5.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image5)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image5
        }
      }else{
        const image5 = document.querySelector('#image5');
        if(image5!==undefined){
          if(image5.files[0]!=undefined){
            var formData = new FormData();
            formData.append('image', image5.files[0]);
            return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
      else{
        return '';
      }
      }
    },

    reset_error(){
      var _this = this
      _this.hasErrors.custnm=false;
      _this.hasErrors.custad1=false;
      _this.hasErrors.custad2=false;
      _this.hasErrors.custpin=false;
      _this.hasErrors.custph=false;
      _this.hasErrors.custeml=false;
      _this.hasErrors.custgst=false;
      _this.hasErrors.custpan=false;
      _this.hasErrors.custcin=false;
      _this.hasErrors.custtan=false;
      _this.hasErrors.custcont=false;
      _this.hasErrors.custcontno=false;
      _this.hasErrors.custconteml=false;
      _this.hasErrors.image1=false;
      _this.hasErrors.image2=false;
      _this.hasErrors.image3=false;
      _this.hasErrors.image4=false;
      _this.hasErrors.image5=false;
      _this.hasErrors.bankname=false;
      _this.hasErrors.banknumber=false;
      _this.hasErrors.bankholder=false;
      _this.hasErrors.bankifsc=false;
      _this.hasErrors.bankbranch=false;
      _this.hasErrors.bankmicr=false;
      _this.hasErrors.bankswift=false;
      _this.hasErrors.supplierprf=false;
    },

    validation(boolean){
      var _this=this
      const image1 = document.querySelector('#image1');
      const image2 = document.querySelector('#image2');
      const image3 = document.querySelector('#image3');
      const image4 = document.querySelector('#image4');
      const image5 = document.querySelector('#image5');

      this.reset_error()

      var submit_true='0';
      var nrex=/^[a-zA-Z\s]{3,100}$/
      var regex=/^[a-zA-Z0-9\s]{3,100}$/
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/
      var prex=/^[0-9]{10,15}$/
      var pirex=/^[0-9]{6}$/
      var accregex=/^[0-9]{3,30}$/
      var eregex= /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/


      // Customer Name
      if (aregex.test(this.customer.name)==false){
        _this.hasErrors.custnm=true;
        submit_true=1
      }else if(this.customer.name.length > 100){
        _this.hasErrors.custnm=true;
        submit_true=1        
      }

      // Customer Address 1
      if(this.customer.add != ""){
        if (aregex.test(this.customer.add)==false){
          _this.hasErrors.custad1=true;
          submit_true=1
        }else if(this.customer.add.length > 100){
          _this.hasErrors.custad1=true;
          submit_true=1      
        }
      }

      // Customer Address 2
      if(this.customer.add2 != ""){
        if (aregex.test(this.customer.add2)==false){
          _this.hasErrors.custad2=true;
          submit_true=1
        }else if(this.customer.add2.length > 100){
          _this.hasErrors.custad2=true;
          submit_true=1
        }
      }

      if(this.customer.profile.length > 255){
        _this.hasErrors.supplierprf=true;
        submit_true=1        
      }

      // Customer Address 2
      if(this.customer.pin != ""){
        if (pirex.test(this.customer.pin)==false){
          _this.hasErrors.custpin=true;
          submit_true=1
        }else if(this.customer.pin.length > 10){
          _this.hasErrors.custpin=true;
          submit_true=1        
        }
      }

      // Customer Phone
      if (prex.test(this.customer.phone)==false){
        _this.hasErrors.custph=true;
        submit_true=1
      }else if(this.customer.phone.length > 15){
        _this.hasErrors.custph=true;
        submit_true=1          
      }


      // Customer Email
      if(this.customer.email != ""){
        if (eregex.test(this.customer.email)==false){
          _this.hasErrors.custeml=true;
          submit_true=1
        }else if(this.customer.email.length > 70){
          _this.hasErrors.custeml=true;
          submit_true=1
        }
      }

      // Customer GST
      if(this.customer.gst != ""){
        if (regex.test(this.customer.gst)==false){
          _this.hasErrors.custgst=true;
          submit_true=1
        }else if(this.customer.gst.length > 15){
          _this.hasErrors.custgst=true;
          submit_true=1
        }
      }

      // Customer PAN
      if(this.customer.pan != ""){
        if (regex.test(this.customer.pan)==false){
          _this.hasErrors.custpan=true;
          submit_true=1
        }else if(this.customer.pan.length > 10){
          _this.hasErrors.custpan=true;
          submit_true=1
        }
      }

      // Customer CIN
      if(this.customer.cin != ""){
        if (regex.test(this.customer.cin)==false)  {
          _this.hasErrors.custcin=true;
          submit_true=1
        }else if(this.customer.cin.length > 25){
          _this.hasErrors.custcin=true;
          submit_true=1
        }
      }

      // Customer TAN
      if(this.customer.tan != ""){
        if (regex.test(this.customer.tan)==false)  {
          _this.hasErrors.custtan=true;
          submit_true=1
        }else if(this.customer.tan.length > 12){
          _this.hasErrors.custtan=true;
          submit_true=1
        }
      }

      // Customer Contact Person Name
      if(this.customer.contact != ""){
        if (nrex.test(this.customer.contact)==false)  {
          _this.hasErrors.custcont=true;
          submit_true=1
        }else if(this.customer.contact.length > 100){
          _this.hasErrors.custcont=true;
          submit_true=1
        }
      }

      // Customer Contact Person No
      if(this.customer.contactno != ""){
        if (prex.test(this.customer.contactno)==false)  {
          _this.hasErrors.custcontno=true;
          submit_true=1
        }else if(this.customer.contactno.length > 15){
          _this.hasErrors.custcontno=true;
          submit_true=1
        }
      }

      // Customer Contact Person No
      if(this.customer.contactemail != ""){
        if (eregex.test(this.customer.contactemail)==false)  {
          _this.hasErrors.custconteml=true;
          submit_true=1
        }else if(this.customer.contactemail.length > 70){
          _this.hasErrors.custconteml=true;
          submit_true=1          
        }
      }

      // Customer Bank Name
      if(this.customer.bankname != ""){
        if (regex.test(this.customer.bankname)==false)  {
          _this.hasErrors.bankname=true;
          submit_true=1
        }else if(this.customer.bankname.length > 20){
          _this.hasErrors.bankname=true;
          submit_true=1          
        }
      }

      // Customer Bank Account Number
      if(this.customer.banknumber != ""){
        if (accregex.test(this.customer.banknumber)==false)  {
          _this.hasErrors.banknumber=true;
          submit_true=1
        }else if(this.customer.banknumber.length > 20){
          _this.hasErrors.banknumber=true;
          submit_true=1          
        }
      }

      // Customer Bank Account Holder
      if(this.customer.bankholder != ""){
        if (regex.test(this.customer.bankholder)==false)  {
          _this.hasErrors.bankholder=true;
          submit_true=1
        }else if(this.customer.bankholder.length > 50){
          _this.hasErrors.bankholder=true;
          submit_true=1          
        }
      }

      // Customer IFSC
      if(this.customer.bankifsc != ""){
        if (regex.test(this.customer.bankifsc)==false)  {
          _this.hasErrors.bankifsc=true;
          submit_true=1
        }else if(this.customer.bankifsc.length > 20){
          _this.hasErrors.bankifsc=true;
          submit_true=1          
        }
      }

      // Customer Bank Branch
      if(this.customer.bankbranch != ""){
        if (regex.test(this.customer.bankbranch)==false)  {
          _this.hasErrors.bankbranch=true;
          submit_true=1
        }else if(this.customer.bankbranch.length > 20){
          _this.hasErrors.bankbranch=true;
          submit_true=1          
        }
      }

      // Customer Bank MICR
      if(this.customer.bankmicr != ""){
        if (regex.test(this.customer.bankmicr)==false)  {
          _this.hasErrors.bankmicr=true;
          submit_true=1
        }else if(this.customer.bankmicr.length > 20){
          _this.hasErrors.bankmicr=true;
          submit_true=1          
        }
      }

      // Customer Bank Swift
      if(this.customer.bankswift != ""){
        if (regex.test(this.customer.bankswift)==false)  {
          _this.hasErrors.bankswift=true;
          submit_true=1
        }else if(this.customer.bankswift.length > 20){
          _this.hasErrors.bankswift=true;
          submit_true=1          
        }
      }
     
      if(image1.files[0]!=undefined){
        if(image1.files[0].size>this.maximumSize){
          this.hasErrors.image1=true;
          this.errorMessage.image1="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image1.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image1=true;
          this.errorMessage.image1="Invalid Image Type"
          submit_true=1
        }
      }

      if(image2.files[0]!=undefined){
        if(image2.files[0].size>this.maximumSize){
          this.hasErrors.image2=true;
          this.errorMessage.image2="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image2.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image2=true;
          this.errorMessage.image2="Invalid Image Type"
          submit_true=1
        }
      }

      if(image3.files[0]!=undefined){
        if(image3.files[0].size>this.maximumSize){
          this.hasErrors.image3=true;
          this.errorMessage.image3="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image3.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image3=true;
          this.errorMessage.image3="Invalid Image Type"
          submit_true=1
        }
      }

      if(image4.files[0]!=undefined){
        if(image4.files[0].size>this.maximumSize){
          this.hasErrors.image4=true;
          this.errorMessage.image4="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image4.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image4=true;
          this.errorMessage.image4="Invalid Image Type"
          submit_true=1
        }
      }

      if(image5.files[0]!=undefined){
        if(image5.files[0].size>this.maximumSize){
          this.hasErrors.image5=true;
          this.errorMessage.image5="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image5.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image5=true;
          this.errorMessage.image5="Invalid Image Type"
          submit_true=1
        }
      }      

      return submit_true
    },

    

    Update(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var submit_true = this.validation()
      var _this=this
      if (submit_true=='0') {
        this.loading=true
          var cust1 = {};
          Promise.all([this.image1(),this.image2(),this.image3(),this.image4(),this.image5()]).then(user=>{
            cust1.cust_cmp_name=this.customer.name
            var dtregex=/^[0-9]{1}$/
                if(_this.birth_dt==null ||_this.birth_dt==''){
                var birth_date=''
                }else{
                var birth_date = new Date(_this.birth_dt)
                console.log(_this.birth_dt)
                console.log(birth_date)
                var year1=birth_date.getFullYear()
                var month1=birth_date.getMonth()+1;
                var daycon=birth_date.getDate();

                if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
                if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

                birth_date=year1+'-'+month1+'-'+day1
                }
                if(_this.anniversary_dt==null || _this.anniversary_dt==''){
                   var anniversary_date=''
                }else{
                 var anniversary_date = new Date(_this.anniversary_dt)
                var year1=anniversary_date.getFullYear()
                var month1=anniversary_date.getMonth()+1;
                var daycon=anniversary_date.getDate();

                if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
                if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

                anniversary_date=year1+'-'+month1+'-'+day1
                }
            if(this.suptype != null){
              cust1.cust_cmp_type=this.suptype.id
            }else{
              cust1.cust_cmp_type=null
            }

            cust1.address1=this.customer.add
            cust1.address2=this.customer.add2
            cust1.pincode=this.customer.pin
            if(this.city != null){
              cust1.city=this.city.id
            }else{
              cust1.city=null       
            }

            if(this.state != null){
              cust1.state_code=this.state.id
            }else{
              cust1.state_code=null
            }

            if(this.con != null){
              cust1.country_code=this.con.id
            }else{
              cust1.country_code=null
            }
             if(_this.anniversary_dt==null ||_this.anniversary_dt==''){
            }else{
               cust1.anniversary_date=anniversary_date
            }
           
             if(_this.birth_dt==null ||_this.birth_dt==''){
             }else{
                cust1.birth_date=birth_date
             }
            cust1.cust_cmp_phone=this.customer.phone
            cust1.cust_cmp_email=this.customer.email
            cust1.cust_cmp_gst=this.customer.gst
            cust1.cust_cmp_pan=this.customer.pan
            cust1.cust_cmp_cin=this.customer.cin
            cust1.cust_cmp_tan=this.customer.tan
            cust1.contact_person_name=this.customer.contact
            cust1.contact_no=this.customer.contactno
            cust1.contact_email=this.customer.contactemail
            cust1.cust_cmp_cic_cert=user[0]
            cust1.cust_cmp_gst_cert=user[1]
            cust1.cust_cmp_pan_cert=user[2]
            cust1.cust_cmp_tan_cert=user[3]
            cust1.cust_cmp_logo=user[4]
            cust1.cust_cmp_profile=this.customer.profile
            cust1.bank_name=this.customer.bankname
            cust1.acc_number=this.customer.banknumber
            cust1.bank_holder_name=this.customer.bankholder
            cust1.ifsc_code=this.customer.bankifsc
            cust1.branch=this.customer.bankbranch
            cust1.micr_code=this.customer.bankmicr
            cust1.swift_code=this.customer.bankswift
            cust1.addr_data = this.addr
            cust1.customer_id = this.customer_id
           
            this.$http.post('/api/customers/update?where[customer_id]='+this.customer_id,cust1).then(function (response){
              _this.$http.post('/api/customerbanks/update?where[customer_id]='+_this.customer_id,cust1).then(function (response){
                _this.$http.post('/api/customerdetails/update?where[customer_id]='+_this.customer_id,cust1).then(function (response){
                    _this.loading=false
                    _this.category=response.data;
                    _this.hasErrors.message=true;
                    _this.errorMessage.message=' Customer Updated Successfully';
                    setTimeout(function(){ _this.errorMessage.message='';}, 2000);
                    _this.reset();
                    _this.getCustomer();
                    _this.largeModal=false
                })
                .catch(function (error) {
                  _this.loading=false
                });
              })
              .catch(function (error) {
                _this.loading=false
              });
            })
            .catch(function (error) {
              _this.loading=false
            });
        });

          //here
      
      this.getshippingDetails(this.customer_id,this.company_id)



      

      }
    },



    Submit(){
      
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var submit_true = this.validation()  
      var _this=this
                var dtregex=/^[0-9]{1}$/
                if(_this.birth_dt==null ||_this.birth_dt==''){
                  var birth_date=''
                  console.log('Nill')
                }else{
                var birth_date = new Date(_this.birth_dt)
                var year1=birth_date.getFullYear()
                var month1=birth_date.getMonth()+1;
                var daycon=birth_date.getDate();

                if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
                if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

                birth_date=year1+'-'+month1+'-'+day1
                }
                if(_this.anniversary_dt==null ||_this.anniversary_dt==''){
                  var anniversary_date =''
                    console.log('Nill')
                }else{
                 var anniversary_date = new Date(_this.anniversary_dt)
                var year1=anniversary_date.getFullYear()
                var month1=anniversary_date.getMonth()+1;
                var daycon=anniversary_date.getDate();

                if(dtregex.test(month1)==true){ var month1='0'+month1 }else{ var month1=month1 }
                if(dtregex.test(daycon)==true){ var day1='0'+daycon }else{ var day1=daycon }

                anniversary_date=year1+'-'+month1+'-'+day1
                }
      if (submit_true == '0') {
          this.loading=true
          var cust = {};
          Promise.all([this.image1(),this.image2(),this.image3(),this.image4(),this.image5()]).then(user=>{
            cust.cust_cmp_name=this.customer.name

            if(this.suptype != null){
              cust.cust_cmp_type=this.suptype.id
            }else{
              cust.cust_cmp_type=null
            }

            cust.address1=this.customer.add
            cust.address2=this.customer.add2
            cust.pincode=this.customer.pin

            if(this.city != null){
              cust.city=this.city.id
            }else{
              cust.city=null       
            }

            if(this.state != null){
              cust.state_code=this.state.id
            }else{
              cust.state_code=null
            }
 
            if(this.con != null){
              cust.country_code=this.con.id
            }else{
              cust.country_code=null
            } 
            cust.cust_cmp_phone=this.customer.phone
            if(_this.anniversary_dt==null ||_this.anniversary_dt==''){
            }else{
               cust.anniversary_date=anniversary_date
            }
           
             if(_this.birth_dt==null ||_this.birth_dt==''){
             }else{
                cust.birth_date=birth_date
             }
            cust.cust_cmp_email=this.customer.email
            cust.cust_cmp_gst=this.customer.gst
            cust.cust_cmp_pan=this.customer.pan
            cust.cust_cmp_cin=this.customer.cin
            cust.cust_cmp_tan=this.customer.tan
            cust.contact_person_name=this.customer.contact
            cust.contact_no=this.customer.contactno
            cust.contact_email=this.customer.contactemail
            cust.cust_cmp_cic_cert=user[0]
            cust.cust_cmp_gst_cert=user[1]
            cust.cust_cmp_pan_cert=user[2]
            cust.cust_cmp_tan_cert=user[3]
            cust.cust_cmp_logo=user[4]
            cust.cust_cmp_profile=this.customer.profile
            cust.bank_name=this.customer.bankname
            cust.acc_number=this.customer.banknumber
            cust.bank_holder_name=this.customer.bankholder
            cust.ifsc_code=this.customer.bankifsc
            cust.branch=this.customer.bankbranch
            cust.micr_code=this.customer.bankmicr
            cust.swift_code=this.customer.bankswift
            cust.shippdetails=this.addr
            this.$http.post('/api/customers',cust).then(function (response){              
              _this.loading=false
              _this.category=response.data;
              _this.hasErrors.message=true;
              _this.errorMessage.message=' Customer Added Successfully';
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
              _this.reset();
              _this.getCustomer();
              _this.largeModal=false
            })
            .catch(function (error) {
              _this.loading=false
              console.log(error)
            });

          });
       }
     },

     ///Dinesh Kahar

       exportData() {
      // alert('data')
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;

      var custname = this.search.custname
      var email = this.search.email
      var contact = this.search.contact
      custname = custname.split(' ').join('_')
      email = email.split(' ').join('_')
      contact = contact.split(' ').join('_')
      if(this.search.custname!=''){
        data=data+"&filter[where][cust_cmp_name][ilike]=%"+custname+"%"
      }
      if(this.search.cmptyp!=null){
        if(this.search.cmptyp.id!=undefined){
          var cmptyp = this.search.cmptyp.id
          data= data+"&filter[where][cust_cmp_type]="+cmptyp          
        }
      }
      if(this.search.email!=''){
        data= data+"&filter[where][cust_cmp_email][ilike]=%"+email+"%"
      }
       if(this.search.contact!=''){
        data= data+"&filter[where][cust_cmp_phone][ilike]=%"+contact+"%"
      }

      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;


      // Need to confirm for relation table where to date start 
      if (this.todate && this.fromdate) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]= " +
          fromdate1 +
          "  &filter[where][lastupdated_datetime][between][1]= " +
          todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      // Need to confirm for relation table where to date end

      if(this.rows.length > 0 ){

      this.$http
        .get(
          "/api/customers/getCustomerCardExport?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          // console.log(response)

          var access_token = localStorage.getItem("authUser");
          //  console.log(response.data)
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          _this.loading = false;
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
              _this.loading = false;
            });
          ///End OF Exce Downlod Method...
        });
      } else {
        _this.loading = false;
        alert('No Data Found')
      }
    },

     reset(){
      var _this=this
      _this.customer.name = ''
      _this.suptype = null
      _this.customer.add = ''
      _this.customer.add2 = ''
      _this.customer.pin = ''
      // _this.con = null
      // _this.state = null
      _this.city = null
      _this.customer.phone = ''
      _this.customer.email = ''
      _this.customer.gst = ''
      _this.customer.pan = ''
      _this.customer.cin = ''
      _this.customer.tan = ''
      _this.customer.contact = ''
      _this.customer.contactno = ''
      _this.customer.contactemail = ''
      document.getElementById("image1").value = ''
      document.getElementById("image2").value = ''
      document.getElementById("image3").value = ''
      document.getElementById("image4").value = ''
      document.getElementById("image5").value = ''
      _this.customer.profile = ''
      _this.customer.bankname = ''
      _this.customer.banknumber = ''
      _this.customer.bankifsc = ''
      _this.customer.bankbranch = ''
      _this.customer.bankmicr = ''
      _this.customer.bankswift = ''
      _this.ed.image1=''
      _this.ed.image2=''
      _this.ed.image3=''
      _this.ed.image4=''
      _this.ed.image5=''
      _this.ed.image1_href=''
      _this.ed.image2_href=''
      _this.ed.image3_href=''
      _this.ed.image4_href=''
      _this.ed.image5_href=''
      _this.address.sname=''
      _this.address.sphn=''
      _this.address.saddress=''
      _this.address.sstate=''
      _this.address.sstateid=''
      _this.address.scity=''
      _this.address.scityid=''
      _this.address.spincode=''
      _this.address.sgst = ''
    },
  }
}
</script>
<style type="text/css">
  .modal-title{
  color:rgb(82, 37, 37);
  font-weight:bold;
  }
</style>







// WEBPACK FOOTER //
// src/views/setting/Customer.vue